import { useCallback } from 'react';
import RoleService from '../services/RoleService';
import { useOptionalPermissions } from '../context/permissionContextCore';

/**
 * `RoleService.can` per i componenti: stesso predicato, ma il componente si ri-renderizza
 * quando i permessi cambiano.
 *
 * `RoleService.can` legge una variabile di modulo, e un componente che la chiama al render
 * non ha motivo di ri-renderizzarsi dopo `refresh()`: i pulsanti resterebbero quelli di
 * prima. Leggere il contesto iscrive il componente ai cambi di permessi; la funzione
 * restituita cambia identita' a ogni nuova Set, cosi' anche le dipendenze degli effetti la
 * vedono cambiare. Il verdetto resta di `RoleService.can`, che i test continuano a mockare.
 *
 * Fuori dai componenti (le guardie di rotta, gli helper puri) si usa `RoleService.can`.
 */
export const useCan = () => {
  const permissions = useOptionalPermissions()?.permissions;
  // `permissions` non compare nel corpo, ed e' voluto: e' la dipendenza che rinnova la
  // funzione quando la Set cambia.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((code) => RoleService.can(code), [permissions]);
};

export default useCan;
